<template>
  <section class="filterable">
    <section class="panel no-print d-print-none">
      <fieldset class="rounded w-100 py-1">
        <legend class="m-0 text-gray"><i class="fa fa-cog"></i> Filtros:</legend>
        <div class="filter">
          <div class="filter-item" v-for="(f, i) in filterCandidates" :key="i">
            <div class="filter-column">
              <div class="form-group">
                <select class="form-control form-control-sm" @input="selectColumn(f, i, $event)">
                  <option value>Selecione o Filtro</option>
                  <optgroup v-for="(group, index) in filterGroups" :key="index" :label="group.name">
                    <option v-for="(x, index) in group.filters" :value="JSON.stringify(x)" :key="index"
                      :selected="f.column && x.name === f.column.name">{{x.title}}</option>
                  </optgroup>
                </select>
              </div>
            </div>
            <div v-show="fetchOperators(f).length !== 1" class="filter-operator" v-if="f.column">
              <div class="form-group">
                <select :disabled="fetchOperators(f).length === 1" class="form-control form-control-sm"
                  @input="selectOperator(f, i, $event)">
                  <option v-for="(y, index) in fetchOperators(f)" :value="JSON.stringify(y)" :key="index"
                    :selected="f.operator && y.name === f.operator.name">{{y.title}}</option>
                </select>
              </div>
            </div>
            <template v-if="f.column && f.operator">
              <div class="filter-full" v-if="f.operator.component === 'single'">
                <input v-if="f.column.type === 'numeric'" placeholder="Insira o valor e pressione enter para pesquisar"
                  v-numericOnly v-on:keyup.enter="applyFilter()" class="form-control form-control-sm"
                  v-model="f.query_1">
                <input v-else v-on:keyup.enter="applyFilter()"
                  placeholder="Digite aqui e pressione enter para pesquisar" class="form-control form-control-sm"
                  v-model="f.query_1">
              </div>
              <template v-if="f.operator.component === 'double'">
                <div class="filter-query_1">
                  <input v-numericOnly placeholder="Insira o valor mínimo" v-on:keyup.enter="applyFilter()"
                    class="form-control form-control-sm" v-model="f.query_1">
                </div>
                <div class="filter-query_2">
                  <input v-numericOnly placeholder="Insira o valor máximo" v-on:keyup.enter="applyFilter()"
                    class="form-control form-control-sm" v-model="f.query_2">
                </div>
              </template>
              <template v-if="f.operator.component === 'datetime_1'">
                <div class="filter-query_1">
                  <input type="text" v-on:keyup.enter="applyFilter()" class="form-control form-control-sm"
                    v-model="f.query_1">
                </div>
                <div class="filter-query_2">
                  <select class="form-control form-control-sm" v-model="f.query_2">
                    <option>horas</option>
                    <option>dias</option>
                    <option>meses</option>
                    <option>anos</option>
                  </select>
                </div>
              </template>
              <template v-if="f.operator.component === 'datetime_2'">
                <div class="filter-query_2">
                  <select class="form-control form-control-sm" v-model="f.query_1">
                    <option value="yesterday">Ontem</option>
                    <option value="today">Hoje</option>
                    <option v-show="f.column.name != 'created_at'" value="tomorrow">Amanhã</option>
                    <option value="last_month">Último Mês</option>
                    <option value="this_month">Esse Mês</option>
                    <option v-show="f.column.name != 'created_at'" value="next_month">Próximo Mês</option>
                    <option value="last_year">Último Ano</option>
                    <option value="this_year">Esse Ano</option>
                    <option v-show="f.column.name != 'created_at'" value="next_year">Próximo Ano</option>
                  </select>
                </div>
              </template>
              <template v-if="f.operator.component === 'datetime_3'">
                <div class="filter-query_1">
                  <input type="date" v-on:keyup.enter="applyFilter()" class="form-control form-control-sm"
                    v-model="f.query_1">
                </div>
                <div class="filter-query_2">
                  <input type="date" v-on:keyup.enter="applyFilter()" class="form-control form-control-sm"
                    v-model="f.query_2">
                </div>
              </template>
              <template v-if="f.operator.component === 'datetime_4'">
                <div class="filter-query_2">
                  <select class="form-control form-control-sm" v-model="f.query_1">
                    <option value="yesterday">Ontem</option>
                    <option value="today">Hoje</option>
                    <option v-show="f.column.name != 'created_at'" value="tomorrow">Amanhã</option>
                    <option value="last_month">Último Mês</option>
                    <option value="this_month">Esse Mês</option>
                    <option v-show="f.column.name != 'created_at'" value="next_month">Próximo Mês</option>
                  </select>
                </div>
              </template>
            </template>
            <template v-if="f.operator.component === 'singleBoolean'">
              <div>
                <select class="form-control form-control-sm" v-model="f.query_1">
                  <option :value="1">Sim</option>
                  <option :value="0">Não</option>
                </select>
              </div>
            </template>
            <template v-if="f.operator.component === 'singlePayment'">
              <div>
                <select class="form-control form-control-sm" v-model="f.query_1">
                  <option :value="1">Pago</option>
                  <option :value="0">Aberto</option>
                </select>
              </div>
            </template>
            <template v-if="f.operator.component === 'listCustom'">
              <div>
                <select class="form-control form-control-sm" v-model="f.query_1">
                  <option :value="''">{{$t('words.select')}}</option>
                  <option v-for="(item, i) in f.data" :key="i" :value="item.value" v-html="item.description"></option>
                </select>
              </div>
            </template>
            <template v-if="['list'].includes(f.operator.component)">
              <div>
                <select class="form-control form-control-sm" v-model="f.query_1">
                  <option :value="''">{{$t('words.select')}}</option>
                  <option v-for="(item, i) in $store.getters[f.column.model]" :key="i" :value="item.id">
                    {{item[f.description]}}</option>

                </select>
              </div>
            </template>
            &nbsp;
            <div class="form-group" v-if="f">
              <button type="button" title="Deletar filtro" aria-label="Deletar filtro" class="btn btn-default btn-sm"
                @click="removeFilter(f, i)">
                <i class="fa fa-trash"></i>
              </button>
            </div>
          </div>
          <div class="filter-controls">
            <button type="button" title="Novo Fitro" aria-label="Novo Fitro" class="btn btn-default btn-sm"
              @click="addFilter">
              <i class="fa fa-plus"></i>
            </button>&nbsp;
            <button type="button" title="Resetar Filtro" aria-label="Resetar Filtro" class="btn btn-default btn-sm"
              @click="resetFilter" v-if="this.appliedFilters.length > 0">
              <i class="fa fa-refresh"></i> Resetar
            </button>
            <button type="button" title="Aplicar Filtro" aria-label="Aplicar Filtro" class="btn btn-sm"
              :disabled="loading" :class="appLayout.btn" @click="applyFilter()">
              <i class="fa fa-check"></i>Aplicar
              Filtro
              <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i>
            </button> &nbsp;
            <div class="btn-group">
              <button type="button" :disabled="headers == undefined || !headers.length"
                class="btn btn-sm btn-default dropdown-toggle" :title="'Configurar colunas'" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-table" aria-hidden="true"></i>
                <span class="caret"></span>
              </button>
              <ul class="dropdown-menu">
                <strong class="ml-2">Exibir Colunas</strong>
                <li v-for="(item, i) in headers" :key="i">
                  <p-check class="ml-2 p-default p-curve p-thick p-smooth text-sm"  @change="handdleCollumn(i)" :color="appLayout.check" :checked="item.visible">
                    {{item.title}}</p-check>
                </li>
              </ul>
            </div>
            <div class="float-right">
              <i class="fa fa-sort-alpha-asc"></i>
              <select class="btn btn-default btn-sm" :disabled="loading" @input="updateOrderColumn">
                <option v-for="(column, index) in orderables" :value="column.name" :key="index"
                  :selected="column && column.name == query.order_column">{{column.title}}</option>
              </select>
              <button type="button" title="Ordernar" aria-label="Ordernar" class="btn btn-default btn-sm"
                @click="updateOrderDirection">
                <span v-if="query.order_direction === 'asc'">
                  <i class="fa fa-arrow-up"></i>
                </span>
                <span v-else>
                  <i class="fa fa-arrow-down"></i>
                </span>
              </button>
            </div>
            <select class="btn btn-sm btn-default ml-2" v-model="query.filter_match">
              <option value="and">Exatamente</option>
              <option value="or">Qualquer</option>
            </select>
            <button v-if="showPrint" @click="getPrint()" style="margin:auto 0.5rem;" class="btn btn-default btn-sm">
              <i class="fa fa-print"></i></button>
            <slot name="custom"></slot>
          </div>
        </div>
      </fieldset>
    </section>
    <section>
      <div class="panel">
        <table class="table table-sm table-hover table-bordered table-condensed">
          <slot name="thead"></slot>
          <tbody v-if="modelo && modelo">
            <slot v-for="(item, i) in modelo" :dropup="i > modelo.length - 3 && modelo.length > 3" :item="item"></slot>
          </tbody>
        </table>
        <div class="panel-footer no-print">
          <div>
            <select class="btn btn-default btn-sm" v-model="query.limit" :disabled="loading" @change="updateLimit">
              <option>5</option>
              <option>10</option>
              <option>15</option>
              <option>25</option>
              <option>50</option>
              <option>100</option>
              <option>150</option>
              <option>300</option>
              <option>500</option>
            </select>
            <small><span v-show="!is_mobile">&nbsp;Mostrando</span> {{collection.from}} - {{collection.to}} de
              {{collection.total}} <span v-show="!is_mobile">registros.</span></small>
          </div>
          <div>
            <router-link v-if="showLinkDeleted" class="btn btn-sm" :to="{ name: `${model}Deleted`}">
              <i class="fa fa-trash"></i>
              {{$t('words.deleted')}}
            </router-link>
            <button type="button" class="btn btn-sm" :disabled="collection.current_page == 1 || loading"
              @click="prevPage">
              <span class="d-sm-none d-md-block">&laquo; Anterior</span>
              <span class="d-lg-none">&laquo;</span>
            </button>
            <button type="button" class="btn btn-sm"
              :disabled="collection.current_page == collection.last_page || loading" @click="nextPage">
              <span class="d-sm-none d-md-block">Próximo &raquo;</span>
              <span class="d-lg-none">&raquo;</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>
<script type="text/javascript">
  import Vue from 'vue';
  import axios from 'axios';
  export default {
    props: {
      url: String,
      storeName: String,
      model: String,
      headers: Array,
      // orderables: Array,
      // filterGroups: Array,
      storeAction: String,
      storeResume: String,
      showLinkDeleted: Boolean,
      disableAutoGet: Boolean,
      showPrint: Boolean,
    },
    data() {
      return {
        loading: false,
        appliedFilters: [],
        filterCandidates: [],
        query: {
          order_column: 'created_at',
          order_direction: 'desc',
          filter_match: 'and',
          limit: 5,
          page: 1
        },
        collection: {
          data: []
        }
      };
    },
    computed: {
      orderables() {
        return this.$store.state[this.model].orderables;
      },
      filterGroups() {
        return this.$store.state[this.model].filterGroups;
      },
      fetchOperators() {
        return f => {
          return this.availableOperators().filter(operator => {
            if (f.column && operator.parent.includes(f.column.type)) {
              return operator;
            }
          });
        };
      },
      is_mobile() {
        const isMobile = window.matchMedia('only screen and (max-width: 760px)');
        return isMobile.matches ? true : false;
      },
      // eslint-disable-next-line vue/return-in-computed-property
      modelo() {
        return _.get(this.$store.state, this.storeName);
      }
    },
    mounted() {
      if (!this.disableAutoGet) {
        this.fetch();
        this.addFilter();
      }
    },
    methods: {
      handdleCollumn(payload) {
        this.$emit('handdleCollumn', payload);
      },
      usedFilter(column) {
        let response = false;
        this.filterCandidates.map((filter) => {
          if (filter.column.name === column.name) {
            response = true;
          }
        });
        return response;
      },
      updateOrderDirection() {
        if (this.query.order_direction === 'desc') {
          this.query.order_direction = 'asc';
        } else {
          this.query.order_direction = 'desc';
        }
        this.applyChange();
      },
      updateOrderColumn(e) {
        const value = e.target.value;
        Vue.set(this.query, 'order_column', value);
        this.applyChange();
      },
      resetFilter() {
        this.appliedFilters.splice(0);
        this.filterCandidates.splice(0);
        this.addFilter();
        this.query.page = 1;
        this.applyChange();
      },
      applyFilter() {
        Vue.set(
          this.$data,
          'appliedFilters',
          JSON.parse(JSON.stringify(this.filterCandidates))
        );
        this.query.page = 1;
        this.applyChange();
      },
      removeFilter(f, i) {
        this.filterCandidates.splice(i, 1);
      },
      selectOperator(f, i, e) {
        let value = e.target.value;
        if (value.length === 0) {
          Vue.set(this.filterCandidates[i], 'operator', value);
          return;
        }
        let obj = JSON.parse(value);
        Vue.set(this.filterCandidates[i], 'operator', obj);
        //this.filterCandidates[i].query_1 = null;
        //this.filterCandidates[i].query_2 = null;
        // set default query
        switch (obj.name) {
          case 'in_the_past':
          case 'in_the_next':
            this.filterCandidates[i].query_1 = 'today';
            this.filterCandidates[i].query_2 = 'days';
            break;
          case 'in_the_peroid':
          case 'in_the_peroid_3':
            this.filterCandidates[i].query_1 = 'today';
            break;
          case 'in_the_peroid_2':
            this.filterCandidates[i].query_1 = new Date().toISOString().substring(0, 10);
            this.filterCandidates[i].query_2 = new Date().toISOString().substring(0, 10);
            break;
        }
      },
      selectColumn(f, i, e) {
        let value = e.target.value;
        if (value.length === 0) {
          Vue.set(this.filterCandidates[i], 'column', value);
          return;
        }
        let obj = JSON.parse(value);
        Vue.set(this.filterCandidates[i], 'column', obj);
        // set default operator: todo
        switch (obj.type) {
          case 'numeric':
            this.filterCandidates[i].operator = this.availableOperators()[4];
            this.filterCandidates[i].query_1 = '';
            this.filterCandidates[i].query_2 = '';
            break;
          case 'string':
          case 'document':
            this.filterCandidates[i].operator = this.availableOperators()[6];
            this.filterCandidates[i].query_1 = '';
            this.filterCandidates[i].query_2 = '';
            break;
          case 'datetime':
            this.filterCandidates[i].operator = this.availableOperators()[9];
            this.filterCandidates[i].query_1 = 'today';
            this.filterCandidates[i].query_2 = 'days';
            break;
          case 'counter':
            this.filterCandidates[i].operator = this.availableOperators()[14];
            this.filterCandidates[i].query_1 = '';
            this.filterCandidates[i].query_2 = '';
            break;
          case 'boolean':
            this.filterCandidates[i].operator = this.availableOperators()[15];
            this.filterCandidates[i].query_1 = 1;
            break;
          case 'datetime2':
            this.filterCandidates[i].operator = this.availableOperators()[16];
            this.filterCandidates[i].query_1 = 'today';
            break;
          case 'listCustom':
            this.filterCandidates[i].operator = this.availableOperators()[17];
            this.filterCandidates[i].query_1 = '';
            this.filterCandidates[i].data = obj.data;
            break;
          case 'list':
            this.filterCandidates[i].operator = this.availableOperators()[18];
            this.filterCandidates[i].query_1 = '';
            //this.filterCandidates[i].data = this.getCustomArraySelect(obj.model);
            this.filterCandidates[i].description = obj.description;
            break;
          case 'payment':
            this.filterCandidates[i].operator = this.availableOperators()[19];
            this.filterCandidates[i].query_1 = 1;
            this.filterCandidates[i].query_2 = '';
            break;
        }
      },
      getCustomArraySelect(model) {
        let arr = [];
        switch (model) {
          default:
            return this.$store.state[model].select;
          case 'boletos':
            return this.$store.state.empresa.boletos;
          case 'conta':
            if (this.$route.name == 'entradas') {
              return this.$store.state.conta.entrada;
            } else if (this.$route.name == 'saidas') {
              return this.$store.state.conta.saida;
            }
            return this.$store.state.conta.select;
          case 'formaPagamento':
            // eslint-disable-next-line no-case-declarations
            this.$store.state.formaPagamento.select.map(item => {
              let obj = {
                id: item.form_codigo,
                form_descricao: item.form_descricao
              };
              arr.push(obj);
            });
            return arr;
          case 'revenda':
            this.$store.state.empresa.revenda.map(emp => {
              let obj = {
                value: emp.id,
                description: emp.empresa_nome
              };
              arr.push(obj)
            })
            return arr;
        }
      },
      addFilter() {
        this.filterCandidates.push({
          column: '',
          operator: '',
          query_1: null,
          query_2: null
        });
      },
      applyChange() {
        this.fetch();
      },
      updateLimit() {
        this.query.page = 1;
        this.applyChange();
      },
      prevPage() {
        if (this.collection.last_page >= this.collection.current_page) {
          this.query.page = Number(this.query.page) - 1;
          this.applyChange();
        }
      },
      nextPage() {
        if (this.collection.current_page < this.collection.last_page) {
          this.query.page = Number(this.query.page) + 1;
          this.applyChange();
        }
      },
      getFilters() {
        const f = {};
        this.appliedFilters.forEach((filter, i) => {
          switch (filter.column.type) {
            case 'numeric':
              filter.query_1 = filter.query_1.replace(',', '.');
              if (filter.query_2) {
                filter.query_2 = filter.query_2.replace(',', '.');
              }
              break;
            case 'document':
              filter.query_1 = filter.query_1.replace(/\D/g, '');
              break;
            case 'payment':
              filter.operator.name = filter.query_1 == 1 ? 'greater_than' : 'equal_to';
              filter.query_1 = 0;
              break;
            case 'listCustom':
              filter.operator.name = 'equal_to';
              break;
            case 'list':
              filter.operator.name = 'equal_to';
              break;
          }
          f[`f[${i}][column]`] = filter.column.name;
          f[`f[${i}][operator]`] = filter.operator.name;
          f[`f[${i}][query_1]`] = filter.query_1;
          f[`f[${i}][query_2]`] = filter.query_2 ?
            filter.query_2 :
            null;
        });
        return f;
      },
      fetch() {
        this.loading = true;
        const filters = this.getFilters();
        const params = {
          ...filters,
          ...this.query
        };
        axios
          .get(this.url, {
            params: params
          })
          .then(res => {
            this.loading = false;
            //console.log(res.data);
            if (res.data.collection) {
              //Salvando os dados na loja.
              this.$store.dispatch(this.storeAction, res.data.collection.data);
              Vue.set(this.$data, 'collection', res.data.collection);
              this.query.page = res.data.collection.current_page;
            }
            if (res.data.resume) {
              this.$store.dispatch(this.storeResume, res.data.resume);
            }
          })
          .catch(error => {
            this.loading = false;
            console.error(error);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      availableOperators() {
        return [{
            title: 'igual a',
            name: 'equal_to',
            parent: ['numeric', 'string', 'document'],
            component: 'single'
          },
          {

            title: 'não é igual a',
            name: 'not_equal_to',
            parent: ['numeric', 'string', 'document'],
            component: 'single'
          },
          {
            title: 'menos que',
            name: 'less_than',
            parent: ['numeric'],
            component: 'single'
          },
          {
            title: 'maior que',
            name: 'greater_than',
            parent: ['numeric'],
            component: 'single'
          },
          {
            title: 'entre',
            name: 'between',
            parent: ['numeric'],
            component: 'double'
          },
          {
            title: 'não entre',
            name: 'not_between',
            parent: ['numeric'],
            component: 'double'
          },
          {
            title: 'contém',
            name: 'contains',
            parent: ['string', 'document'],
            component: 'single'
          },
          {
            title: 'começa com',
            name: 'starts_with',
            parent: ['string', 'document'],
            component: 'single'
          },
          {
            title: 'termina com',
            name: 'ends_with',
            parent: ['string', 'document'],
            component: 'single'
          },
          /*
          {
            title: "no passado",
            name: "in_the_past",
            parent: ["datetime"],
            component: "datetime_1"
          },
          {
            title: "na próxima",
            name: "in_the_next",
            parent: ["datetime"],
            component: "datetime_1"
          },
          */
          {
            title: 'no período',
            name: 'in_the_peroid',
            parent: ['datetime'],
            component: 'datetime_2'
          },
          {
            title: 'entre os dias',
            name: 'in_the_peroid_2',
            parent: ['datetime'],
            component: 'datetime_3'
          },
          {
            title: 'igual a',
            name: 'equal_to_count',
            parent: ['counter'],
            component: 'single'
          },
          {
            title: 'não é igual a',
            name: 'not_equal_to_count',
            parent: ['counter'],
            component: 'single'
          },
          {
            title: 'menor que',
            name: 'less_than_count',
            parent: ['counter'],
            component: 'single'
          },
          {
            title: 'maior que',
            name: 'greater_than_count',
            parent: ['counter'],
            component: 'single'
          },
          {
            title: 'Igual a',
            name: 'equal_to',
            parent: ['boolean'],
            component: 'singleBoolean'
          },
          {
            title: 'no período',
            name: 'in_the_peroid_3',
            parent: ['datetime2'],
            component: 'datetime_4'
          },
          {
            title: 'Igual a',
            name: 'equal_to',
            parent: ['listCustom'],
            component: 'listCustom'
          },
          {
            title: 'Igual a',
            name: 'equal_to',
            parent: ['list'],
            component: 'list'
          },
          {
            title: 'Igual a',
            name: 'equal_to',
            parent: ['payment'],
            component: 'singlePayment'
          },
        ];
      },
      getParams() {
        Vue.set(
          this.$data,
          'appliedFilters',
          JSON.parse(JSON.stringify(this.filterCandidates))
        );
        this.query.page = 1;
        const filters = this.getFilters();
        const params = {
          ...filters,
          ...this.query
        };
        return params;
      },
      getTotalData() {
        return this.collection.total;
      }
    }
  };
</script>

<style scoped>
  .panel {
    background: #fff;
    margin-bottom: 16px;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  }

  .panel-heading {
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(63, 63, 68, 0.1);
  }

  .panel-title {
    font-size: 18px;
    line-height: 24px;
  }

  .panel-body {
    padding: 8px;
  }

  .panel-footer {
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid rgba(63, 63, 68, 0.1);
  }

  fieldset {
    border: 1px solid #d2d6de !important;
    padding: 0 1.4em 0.5rem !important;
    margin: 0 0 1em 0 !important;
    box-shadow: 0 0 0 0 #000;
  }

  legend {
    font-size: 1em !important;
    font-weight: 700 !important;
    text-align: left !important;
    width: auto;
    padding: 0 10px;
    border-bottom: none;
  }

  .form-group {
    margin: 0;
  }

  .filter-item {
    margin-bottom: 15px;
    display: flex;
  }

  .filter-column {
    padding-right: 15px;
    width: 25%;
  }

  .filter-operator {
    padding-right: 15px;
    width: 25%;
  }

  .filter-query_1 {
    width: 24%;
    padding-right: 15px;
  }

  .filter-full {
    width: 48%;
  }

  .filter-query_2 {
    width: 24%;
  }

  .filter-remove {
    width: 2%;
    text-align: right;
  }

  .filter-remove button {
    color: #e75650;
    background: transparent;
    border: none;
    font-weight: bold;
  }

  .filterable-export {
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
  }

  /*
.my-table {
  min-height: 90vh
}
*/
</style>